export const languages = {
  vi: {
    homePage: 'Trang chủ',
    library: 'Thư viện',
    author: 'Tác giả',
    description: 'Mô tả',
    goToLibrary: 'Xem thư viện',
    introduction: {
      title: 'Quản lí thư viện',
      line1: 'Thư viện khổng lồ.',
      line2: 'Cập nhật hàng ngày.',
      line3: 'Lưu trữ sách.',
      line4: 'Được viết bởi những người yêu sách.',
    },

    actions: {
      addAuthor: 'Tạo tác giả mới',
      addBook: 'Tạo sách mới',
      changePassword: 'Đổi mật khẩu',
    },
    inputLabels: {
      imageUrl: 'Đường dẫn hình ảnh',
      title: 'Tiêu đề sách',
      description: 'Mô tả (tiếng Anh)',
      publisher: 'Nhà xuất bản',
      author: 'Tác giả',
      firstName: 'Tên',
      lastName: 'Họ',
      oldPassword: 'Mật khẩu hiện tại',
      newPassword: 'Mật khẩu mới',
      confirmPassword: 'Xác nhận mật khẩu',
    },
    inputPlaceholder: {
      username: 'Nhập tên người dùng...',
      imageUrl: 'Nhập đường dẫn hình ảnh...',
      firstName: 'Nhập tên... (không bắt buộc)',
      lastName: 'Nhập họ... (không bắt buộc)',
      isbn: 'Nhập ISBN...',
      title: 'Nhập tiêu đề sách...',
      description: 'Nhập mô tả (tiếng Anh)',
      publisher: 'Nhập nhà xuất bản...',
      author: 'Nhập tác giả...',
      email: 'Nhập email... ',
      oldPassword: 'Nhập mật khẩu hiện tại...',
      newPassword: 'Nhập mật khẩu mới...',
      search: 'Tìm kiếm...',
      password: 'Nhập mật khẩu...',
      confirmPassword: 'Nhập lại mật khẩu...',
      confirmNewPassword: 'Nhập lại mật khẩu mới...',
    },
    buttonsText: {
      updateInfo: 'Cập nhật thông tin',
      borrow: 'Đặt sách',
      return: 'Trả sách',
      unavailable: 'Sách đã có người đặt',
    },
    modalsText: {
      bookInfo: 'Chi tiết',
    },
    user: {
      signIn: 'Đăng nhập',
      signUp: 'Đăng kí',
      signOut: 'Đăng xuất',
      username: 'Tên đăng nhập',
      password: 'Mật khẩu',
      confirmPassword: 'Xác nhận mật khẩu',
      firstName: 'Tên',
      lastName: 'Họ',
      checkbox: 'Tôi đồng ý với các điều khoản sử dụng',
      info: 'Tài khoản',
      books: 'Sách của bạn',
      signInAs: 'Tài khoản',
      logInGoogle: 'Đăng nhập bằng Google',
      forgetPassword: 'Quên mật khẩu?',
      passwordNoMatch: 'Xác nhận mật khẩu không giống nhau',
    },
    emptyPage: {
      nothingToDisplay: 'Không có gì để hiển thị',
      checkoutSomeBooks: 'Đến trang mượn sách',
      nothingFound: 'Không có kết quả...',
    },

    misc: {
      cannotChangeGooglePassword:
        'Không thể đổi mật khẩu khi đăng nhập bằng Google.',
    },
  },

  en: {
    homePage: 'Home',
    library: 'Library',
    author: 'Authors',
    goToLibrary: 'Go to library',
    introduction: {
      title: 'Your personal book keeper',
      line1: 'Large database of books.',
      line2: 'Update daily.',
      line3: 'Store your favorite books',
      line4: 'Built by book enthusiasts.',
    },

    actions: {
      addAuthor: 'Add New Author',
      addBook: 'Add New Book',
      changePassword: 'Change Password',
    },

    inputLabels: {
      imageUrl: 'Image URL',
      title: 'Title',
      description: 'Description',
      publisher: 'Publisher',
      author: 'Author',
      firstName: 'First Name',
      lastName: 'Last Name',
      oldPassword: 'Old password',
      newPassword: 'New password',
      confirmPassword: 'Confirm password',
    },
    inputPlaceholder: {
      username: 'Enter username...',
      password: 'Enter password...',
      imageUrl: 'Enter Image URL...',
      firstName: 'Enter first name... (optional)',
      lastName: 'Enter last name... (optional)',
      isbn: 'Enter ISBN...',
      title: 'Enter title...',
      description: 'Enter description...',
      publisher: 'Enter publisher...',
      author: 'Enter author...',
      email: 'Enter your email...',
      confirmPassword: 'Enter Password again...',
      oldPassword: 'Enter old password...',
      newPassword: 'Enter new password...',
      search: 'Search something...',
      confirmNewPassword: 'Confirm new password...',
    },
    buttonsText: {
      updateInfo: 'Update Info',
      borrow: 'Borrow',
      return: 'Return',
      unavailable: 'Borrowed',
    },
    modalsText: {
      bookInfo: 'Book Info',
    },
    user: {
      signIn: 'Sign In',
      signUp: 'Sign Up',
      signOut: 'Sign Out',
      username: 'Username',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      checkbox: 'I agree to the terms and conditions',
      info: 'User Info',
      books: 'Your books',
      signInAs: 'Signed in as',
      logInGoogle: 'Login with Google',
      forgetPassword: 'Forget Password?',
      passwordNoMatch: "Passwords don't match",
    },
    emptyPage: {
      nothingToDisplay: 'Nothing to display here',
      checkoutSomeBooks: 'Check out some books here',
      nothingFound: 'Nothing found...',
    },
    misc: {
      cannotChangeGooglePassword:
        "Your account is logged in with Google, hence we can't change your password.",
    },
  },
}
